export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de entregas"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detalle de entrega"])},
          "delivery_items": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Items"])}
        }
      }
    }
  })
}